import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SalesContractFolderHdrContainerModel } from "../../../../../../models/aggregates/erp/sales-contract";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../../shared";

@Injectable({ providedIn: "root" })
export class SalesContractFolderHdrService extends BaseApiTemplateService<SalesContractFolderHdrContainerModel> {
  static readonly SALES_CONTRACT_FOLDER_HDR_SUBPATH =
    "sales-contract-folder-hdrs/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractFolderHdrService.SALES_CONTRACT_FOLDER_HDR_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractFolderHdrService.SALES_CONTRACT_FOLDER_HDR_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  initializeSCFolder(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        SalesContractFolderHdrService.SALES_CONTRACT_FOLDER_HDR_SUBPATH +
        "template-hdrs/" +
        BaseApiTemplateService.BACKOFFICE_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
